/**
 * Claim my Content Component
 *
 * Display list of users content and allows an item to be claimed.
 */

import React from 'react';
import ReactDOM from 'react-dom';

import { AuthButtonGroup } from '../../common/components/buttonGroups.jsx';
import { Grid } from '../../apps/UgcWall/components/modules/SocialContentWall.jsx';
import { ContentClaim } from '../../common/components/displayItems/claim.jsx';

// Factories.
import { createDisplayItemEntityFromJSON } from '../../factories/displayItem.js';

import * as formUtil from '../utils/formUtils';
import { capitalize } from '../utils/utils';

export default (function(w, d, $, _, undefined) {
  // Campaign entry item model [TODO: Make global]

  var CampaignEntryDisplayItem = Backbone.Model.extend({
    idAttribute: 'entryId',

    parse: function(obj) {
      if (!obj.linkTitle) obj.linkTitle = NGX.lang.get('buttons.claim');
      return obj;
    },
  });

  // Collection of campaign entries
  var CampaignEntries = Backbone.Collection.extend({
    url:   NGX.config.displayContServiceV2URL + '/api/content/3/claim',
    model: CampaignEntryDisplayItem,
    parse: function(response) {
      return response.content;
    },
  });

  // EntryListView - the sub view to render the list of campaign entry items

  // contentclaim component view
  var ContentClaimView = Backbone.View.extend({
    initialize: function() {
      _.bindAll(
        this,
        'handleLoginButtonClick',
        'doNetworkLogin',
        'createCollection',
        'addAll',
        'addItem',
        'handleContentSelection'
      );

      this.formEl = document.getElementById('xCampaignForm');
      this.formWrap = this.formEl.parentElement;
      this.buttonsEl = document.getElementById('xContentClaimButtons');
      this.listEl = document.getElementById('xContentClaimList');

      this.listenTo(
        this.model,
        'change',
        function() {
          this.render();
        }.bind(this)
      );
      this.listenTo(this.model, 'change:userid', this.createCollection);

      // Listen for auth redirects.
      NGX.App.Events.on(
        'auth:redirect',
        function(networkId) {
          this.doNetworkLogin(networkId);
        }.bind(this)
      );
    },

    render: function() {
      var _networks = [];
      _.each(this.model.get('innetworkConfig'), function(v, k) {
        if (v.enabled) _networks.push(k);
      });

      if (_networks.length > 0) {
        var buttonGroup = React.createElement(
          AuthButtonGroup,
          {
            networks: _networks,
            onClick:  this.handleLoginButtonClick,
          },
          null
        );

        ReactDOM.render(buttonGroup, document.getElementById('xContentClaimButtons'));

        // Show the claim stuff, hide the form [TODO: Kill the jQuery]
        $(this.formWrap).hide();
        $(this.listEl).show();
      } else {
      }
    },

    handleLoginButtonClick: function(e) {
      // Get the network from the clicked element.
      var _network = e.currentTarget.getAttribute('data-ngx-network');
      this.doNetworkLogin(_network);
    },

    // Handle login
    doNetworkLogin: function(network) {
      var _cmp = this;

      var _success = function(user) {
          if (user) {
            this.model.set({
              userid:     user.id,
              sourceName: user.sourceName,
              network:    network.toLowerCase(),
              user:       user,
            });
            this.$('.xButtonToolbar').fadeOut();
          }
        }.bind(this),
        _fail = function() {
          this.$('#xOAuthStatus>p')
            .text('We could not log you in')
            .fadeIn();
        }.bind(this);

      this.model.set('userid', null);

      NGX.Auth.login(network, {
        success: _success,
        fail:    _fail,
      });
    },

    // Handle content claim

    handleContentSelection: function(e, item) {
      // Show the claim stuff, hide the form [TODO: Kill the jQuery]

      var selectedEl = $(e.currentTarget);

      try {
        var _assets = item.assets,
          _profile = item.profile;

        if (_assets.main) {
          NGX.App.api.setFormField('assetRef', _assets.main);
        }

        if (_assets.thumbnail) {
          NGX.App.api.setFormField('thumbnailAssetRef', _assets.thumbnail);
        }

        if (item.content.link) {
          NGX.App.api.setFormField('ngxFeaturedLink', item.content.link);
        }
      } catch (e) {
        log.debug('Could not populate featured link', 5);
      }

      try {
        NGX.App.api.setFormField(
          'ngxFeaturedComment',
          NGX.Util.stripHTMLTags(item.content.caption) || item.content.content
        );
      } catch (e) {
        log.debug('Could not find populate featured comment', 5);
      }

      const user = this.model.get('user');
      if (user) {
        $('[data-ngx-populate=firstname]').val(user.firstName);
        $('[data-ngx-populate=lastname]').val(user.lastName);
        $('[data-ngx-populate=email]').val(user.email);
      }

      if (_profile) {
        NGX.App.api.setFormField('ngxAvatar', _profile.avatar);
        NGX.App.api.setFormField('ngxSourceId', _profile.userid);
        NGX.App.api.setFormField('ngxSourceProfile', _profile.handle);
      }

      selectedEl
        .addClass('selected')
        .find('.xButton')
        .hide();

      $('.xItem', $(this).listEl)
        .not(selectedEl)
        .fadeOut('fast');
      $(this.formWrap).fadeIn('slow', formUtil.formWrapperResize);
    },

    // Show and populate list of content to claim

    // create a named collection within this view
    createCollection: function(name) {
      var _userId = this.model.get('userid'),
        _this = this,
        _network = this.model.get('network'),
        _user = this.model.get('user');

      //if(!isNaN(_userId) && parseInt(_userId)>0){ // Can't do this because Flickr use rubbish UID's
      if (_userId) {
        // Get source name.
        var _sourceName = this.model.get('sourceName');

        // Clear down the list
        this.listEl.innerHTML = '';
        var list = (this[name] = new CampaignEntries({
            el: this.listEl,
          })),
          params = {
            campaignId: NGX.App.config.id,
            apikey:     NGX.context.apikey,
            network:    this.model.get('network'),
            nocache:    Math.random(),
            stageMode:  NGX.Browser.queryStringObject('stageMode') == 'true',
          };

        // Switch behaviour for specific networks.
        switch (_network) {
          // Instagram.
          case 'instagram':
            // Pull the source name from profile data.
            _sourceName = _user.associatedData.profileUsername;
            params.sourceId = _sourceName;
            break;

          // All other networks.
          default:
            params.sourceId = _userId;
            params.sourceName = _sourceName;
            break;
        }

        // if we're in preview mode pass the parameter
        if (NGX.context.isPreview === true) {
          params.preview = true;
        }
        this.listenTo(list, 'sync', this.addAll);
        this.listenTo(list, 'add', this.addItem);

        list.fetch({
          success: function(collection, response, xhr) {
            if (collection.models.length > 0) {
              this.$('#xOAuthStatus>p')
                .html(NGX.lang.get('rights.messages.legal'))
                .fadeIn();
            } else {
              this.$('#xOAuthStatus>p')
                .text(NGX.lang.get('ugc.claim.nocontent'))
                .fadeIn();
            }
          }.bind(this),
          data: params,
        });
      }
    },
    // build & render views for a whole collection
    addAll: function(collection) {
      var templateOpts = this.model.get('templateOpts');
      var comp = this.model.get('component');

      // TODO: If a specific DisplayItem component exists, use it; else fall back to NGXDisplayItem
      // var preferred = 'NGXDisplayItem'+templateOpts.itemTemplate.capitalize();

      var itemFactory = ContentClaim; //window[preferred]||NGXDisplayItemClaim;

      var rows = collection.map(function(model, idx) {
        // Proptype checking against React components is now much more strict, we must create a DisplayItem instance before
        // passing it to the component.
        const displayItem = createDisplayItemEntityFromJSON(model.attributes);

        var item = React.createElement(
          itemFactory,
          {
            key:          'di-' + idx,
            item:         displayItem,
            templateOpts: templateOpts,
            onClick:      this.handleContentSelection,
            assetUrl:     NGX.context.assetUrl,
            assetUgcUrl:  NGX.context.assetUgcUrl,
          },
          null
        );

        return item;
      }, this);

      var classNames = ['xContainer'];

      //TODO [SG]: Create utils for this
      classNames.push('xContainer' + capitalize(comp.type));
      classNames.push('xTemplate' + capitalize(templateOpts.collectionType));
      classNames.push('xClass' + capitalize(templateOpts.collectionClass));
      classNames.push('xItemCount' + rows.length);
      classNames.push('hasItem' + capitalize(templateOpts.itemTemplate.toLowerCase()));
      if (templateOpts.variant) classNames.push('hasVariant' + capitalize(templateOpts.variant));

      if (comp.data && comp.data.render) {
        classNames.push('xRender' + capitalize(comp.data.render));
      }

      var grid = React.createElement(Grid, { className: classNames.join(' ') }, rows);

      ReactDOM.render(grid, this.listEl);
    },
    // build and render an item view from its model
    addItem: function(model) {
      var obj = {
        model:     model,
        template:  this.itemTemplate,
        component: this,
      };
      //this.$list.append( new RightsItemView( obj ).render().el );
    },
  });

  return {
    init: function() {
      NGX.comps.push({ type: 'form', view: ContentClaimView });
    },
  };
})(window, document, jQuery, _);
